/**
 * POLAZIŠTE MODULA (D15-A §1a) — jedno mjesto na kojem se procesno stanje vraća
 * na početak.
 *
 * **Nalaz.** Puna suita je znala pasti ondje gdje nijedan test solo ne pada, i to
 * u PRVOJ tvrdnji datoteke. Uzrok nije bio ekran nego ono što modul pamti između
 * dva testa: sesija osoblja, zapamćen jezik zahtjeva, odgovor o WebGL-u, "novo
 * izdanje je objavljeno". Svaki od njih ima svoj `_reset`, i svaki se dotad zvao
 * RUČNO — u `beforeEach`-u one datoteke koja se toga sjetila. Test koji se ne
 * sjeti ne pada sam; pada onaj koji dođe poslije njega.
 *
 * **Lijek nije još jedan popis nego OBRNUT smjer.** Modul koji drži procesno
 * stanje sam se ovdje prijavi jednom rečenicom, a zajednički `beforeEach`
 * (`test/setup.ts`) vrati sve prijavljene na polazište. Prednosti su dvije, i obje
 * su o onome što se NE mora zapamtiti:
 *
 * · **nema propuštenih**: novi modul s vlastitim `let` stanjem pokriven je onog
 *   trenutka kad se prijavi, bez izmjene u ijednom testu;
 * · **nema skupog uvoza**: vraća se samo ono što je test STVARNO uvezao — modul
 *   koji se u tom testu ne pojavljuje nije ni registriran, pa `setup.ts` ne mora
 *   povlačiti kartu, push ni sesiju gosta da bi ih očistio.
 *
 * Cijena u isporuci je niz i dvije funkcije; prijava je jedan poziv po modulu, pri
 * učitavanju.
 */

/** Vraćanja koja su se modul po modul prijavila pri učitavanju. */
const vracanja: (() => void)[] = []

/**
 * Modul objavljuje kako se vraća na polazište.
 *
 * Zove se u tijelu modula (dakle jednom, pri prvom uvozu), a ne u komponenti:
 * predmet je stanje MODULA, ne stanje ekrana.
 */
export function pamtiPolaziste(vrati: () => void): void {
  vracanja.push(vrati)
}

/**
 * Sve prijavljeno natrag na polazište.
 *
 * **Ne baca.** Jedan modul koji se buni pri čišćenju srušio bi `beforeEach` i s
 * njim SVAKI sljedeći test u datoteci — a to je upravo kvar koji se ovime
 * zatvara. Kvar u čišćenju je zato tiho preskočen; ono što je stvarno palo vidjet
 * će se u testu koji na to stanje računa.
 */
export function vratiPolaziste(): void {
  for (const vrati of vracanja) {
    try {
      vrati()
    } catch {
      /* Čišćenje ne smije biti razlog pada. */
    }
  }
}
